import React, { useRef, useState, useEffect } from "react"
import useOutsideClick from "../../hooks/useOutsideClick"
import { SvgCheckbox, SvgChevronDown } from "../icons/"

interface Props {
  selectedSort: string
  selectedFilter: string
  setSelectedSort: any
  setSelectedFilter: any
  coaches: any[]
  setCoaches: any
  contacts: any[]
}

const CoachDirectoryFilters: React.FC<Props> = ({
  selectedSort,
  selectedFilter,
  setSelectedSort,
  setSelectedFilter,
  coaches,
  setCoaches,
  contacts,
}) => {
  const [sortByExpanded, setSortByExpanded] = useState<boolean>(false)
  const [originalCoaches, setOriginalCoaches] = useState<any[]>([])
  const ref = useRef(null)

  useOutsideClick(ref, () => {
    if (sortByExpanded) {
      setSortByExpanded(false)
    }
  })

  useEffect(() => {
    setOriginalCoaches(coaches)
  }, [])

  const toggleSortBy = () => {
    setSortByExpanded(!sortByExpanded)
  }

  const safeGetNamePart = (coach: any, part: number) => {
    return part === 0 ? coach.first_name || "" : coach.last_name || ""
  }

  const sortCoachesBy = (sortValue: string) => {
    setSelectedFilter("")

    if (sortValue === "none") {
      setCoaches([...originalCoaches])
      setSelectedSort("none")
      return
    }

    let sorted = [...originalCoaches]

    if (sortValue === "first") {
      sorted = sorted.sort((a: any, b: any) =>
        safeGetNamePart(a, 0).localeCompare(safeGetNamePart(b, 0), undefined, {
          sensitivity: "base",
        })
      )
    } else if (sortValue === "last") {
      sorted = sorted.sort((a: any, b: any) =>
        safeGetNamePart(a, 1).localeCompare(safeGetNamePart(b, 1), undefined, {
          sensitivity: "base",
        })
      )
    } else if (sortValue === "connected") {
      sorted = originalCoaches.filter((coach) =>
        contacts.some(
          (contact) => contact.profile_id === coach.coach_profile_id
        )
      )
    } else if (sortValue === "not connected") {
      sorted = originalCoaches.filter(
        (coach) =>
          !contacts.some(
            (contact) => contact.profile_id === coach.coach_profile_id
          )
      )
    }

    setCoaches(sorted)

    setSelectedSort(sortValue)
  }

  return (
    <div className="flex items-center gap-[32px]">
      <div className="relative" ref={ref}>
        <button
          className="flex items-center gap-[8px] font-bold text-base"
          onClick={toggleSortBy}
        >
          Sort by
          <SvgChevronDown
            className={`${sortByExpanded ? "rotate-[180deg]" : ""}`}
          />
        </button>
        {sortByExpanded && (
          <div
            className="absolute right-0 top-[40px] py-[24px] px-[32px] bg-white
                        rounded-[12px] main-shadow flex flex-col z-[300]"
          >
            <span className="mb-[16px] text-graySlate text-base mr-auto">
              Sort by
            </span>
            <div className="w-[184px] flex flex-col gap-[10px] text-base">
              <button
                className="flex items-center justify-between w-full"
                onClick={() => sortCoachesBy("none")}
              >
                None
                <div
                  className={`w-[24px] h-[24px] border border-1 border-grayCloud rounded-[8px] bg-transparent
                flex items-center justify-center
                ${selectedSort === "none" && "bg-blurple"}`}
                >
                  {selectedSort === "none" && <SvgCheckbox />}
                </div>
              </button>
              <button
                className="flex items-center justify-between w-full"
                onClick={() => sortCoachesBy("first")}
              >
                First Name
                <div
                  className={`w-[24px] h-[24px] border border-1 border-grayCloud rounded-[8px] bg-transparent
                flex items-center justify-center
                ${selectedSort === "first" && "bg-blurple"}`}
                >
                  {selectedSort === "first" && <SvgCheckbox />}
                </div>
              </button>
              <button
                className="flex items-center justify-between w-full"
                onClick={() => sortCoachesBy("last")}
              >
                Last Name
                <div
                  className={`w-[24px] h-[24px] border border-1 border-grayCloud rounded-[8px] bg-transparent
                flex items-center justify-center
                ${selectedSort === "last" && "bg-blurple"}`}
                >
                  {selectedSort === "last" && <SvgCheckbox />}
                </div>
              </button>
              <button
                className="flex items-center justify-between w-full"
                onClick={() => sortCoachesBy("connected")}
              >
                Connected
                <div
                  className={`w-[24px] h-[24px] border border-1 border-grayCloud rounded-[8px] bg-transparent
                flex items-center justify-center
                ${selectedSort === "connected" && "bg-blurple"}`}
                >
                  {selectedSort === "connected" && <SvgCheckbox />}
                </div>
              </button>
              <button
                className="flex items-center justify-between w-full"
                onClick={() => sortCoachesBy("not connected")}
              >
                Not Connected
                <div
                  className={`w-[24px] h-[24px] border border-1 border-grayCloud rounded-[8px] bg-transparent
                flex items-center justify-center
                ${selectedSort === "not connected" && "bg-blurple"}`}
                >
                  {selectedSort === "not connected" && <SvgCheckbox />}
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CoachDirectoryFilters
